import { Route } from 'react-router-dom';
import SkeletonPage from '../modules/skeleton/SkeletonPage';
import { Suspense, lazy } from 'react';

const Stocks = lazy(() => import('../modules/stocks'));

const StocksTable = lazy(
  () => import('../modules/stocks/pages/StocksTable')
);

const StockIssueKanban = lazy(
  () => import('../modules/stocks/pages/StockIssueKanban')
);

const StocksRoutes = (
  <>
    <Route
      path="stocks"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <Stocks />
        </Suspense>
      }
    >
      <Route
        path=""
        element={
          <Suspense fallback={<SkeletonPage />}>
            <StocksTable />
          </Suspense>
        }
      />
      <Route
        path="issue-stock"
        element={
          <Suspense fallback={<SkeletonPage />}>
            <StockIssueKanban />
          </Suspense>
        }
      />
    </Route>
  </>
);

export default StocksRoutes; 